<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// ===== QUICK CART MOBILE SCROLL FIX (iOS/Safari) =====
(function () {
  function isCartOpen() {
    return document.body.classList.contains('openCartSidebar') ||
           document.body.classList.contains('cart-sidebar-open') ||
           document.querySelector('#halo-cart-sidebar')?.classList.contains('is-open') ||
           document.querySelector('#halo-cart-sidebar')?.classList.contains('open') ||
           document.querySelector('#halo-cart-sidebar')?.classList.contains('active');
  }

  // iOS: Drawer içindeyken touchmove'ı serbest bırak, dışarıda engelle
  function onTouchMove(e) {
    const insideScrollable = e.target.closest('#halo-cart-sidebar .halo-sidebar-content, #halo-cart-sidebar .previewCartList, #halo-cart-sidebar .previewCart');
    if (insideScrollable) {
      // dışarıdaki "preventDefault" yapan handler'lara gitmesin
      e.stopPropagation();
      return;
    }
    if (isCartOpen()) {
      e.preventDefault();
    }
  }

  // capture:true -> çoğu temadaki body/document bubble kilidini kırar
  document.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });

  // Wheel (desktop/mobile trackpad) için de aynı mantık
  document.addEventListener('wheel', function(e){
    const insideScrollable = e.target.closest('#halo-cart-sidebar .halo-sidebar-content, #halo-cart-sidebar .previewCartList, #halo-cart-sidebar .previewCart');
    if (insideScrollable) return;
    if (isCartOpen()) e.preventDefault();
  }, { passive: false, capture: true });
})();